import { FlexiSlider } from "appworks/graphics/elements/flexi-slider";
import { FlexiText } from "appworks/graphics/elements/flexi-text";
import { Sprite } from "appworks/graphics/pixi/sprite";
import { gameiomModel } from "gameiom/model/gameiom-model";
import { AgsAbstractSliderControl } from "./ags-abstract-slider-control";

export abstract class AgsAbstractAutoplaySliderControl extends AgsAbstractSliderControl {
    constructor(slider: FlexiSlider, label: FlexiText, title: FlexiText, background: Sprite) {
        super(slider, label);

        if (gameiomModel.preSelectAutoplayOptions) {
            const modelData = this.getModelData();
            this.saveModelData(modelData.lastSelectedValue ?? modelData.defaultValue);
        }

        const hasNoOptions = this.getModelData().values.length <= 0;
        if (hasNoOptions) {
            slider.setVisible(false);
            label.setVisible(false);
            title.setVisible(false);
            background.visible = false;
            this.saveModelData(Number.MAX_VALUE);
        }
    }
}
